export default {"src":"/_next/static/media/MedicalCrossDark.a13cb554.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};